// Feuille de style en ligne d'un écran historique, rangée dans la couche `legacy` comme globals.css (#596).
// Une balise <style> hors couche l'emporterait sur toutes les règles globales, quelle que soit leur spécificité
// (ex. `.table-wrapper { overflow-x: auto }` contre `.table-wrapper:has(> .stack-table)`, #404) ; dans la même
// couche, spécificité puis ordre décident, comme avant les couches. Le code neuf utilise Tailwind et les tokens.
export default function LegacyStyle({ css }: { css: string }) {
  return <style dangerouslySetInnerHTML={{ __html: `@layer legacy {\n${css}\n}` }} />;
}
